import queryClient from '../../queryClient'
import QueryKeys from '../constants/queryKeys'
import localStorageIds from '../constants/localStorageIds'
import getUserData from '../../Apis/user/getUserData'
import { setLocalStorageValue } from './localStorageHelperMethods'

// What the user may do per org (role, add-ons, permissions) comes from /users/me, never from the
// token: the server decides it on every request and the token will stop carrying it.
export const storeAccess = ({ userOrgAddons, orgRoles, permissions, competitionPermissions } = {}) =>
  setLocalStorageValue([
    { id: localStorageIds.ADDONS, value: userOrgAddons ?? {} },
    { id: localStorageIds.USER_ORG_ROLES, value: orgRoles ?? {} },
    { id: localStorageIds.ORG_PERMISSIONS, value: permissions ?? {} },
    { id: localStorageIds.COMPETITION_PERMISSIONS, value: competitionPermissions ?? {} },
  ])

// Loads it before the first screen of a new session, which redirects on it (statisticians land on
// the profile). On failure the layout's /users/me query keeps retrying and fills it in.
const loadAccess = async () => {
  try {
    storeAccess(await queryClient.fetchQuery([QueryKeys.GET_ACCOUNT_ME], () => getUserData()))
  } catch {
    // See above.
  }
}

export default loadAccess
